import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const EmailReportApi = createApi({
  reducerPath: "EmailReportApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Start Hobbies API's---------------------------------------
    getAllEmailReport: builder.query({
      query: () => "emailConfig",
      transformResponse: (response) => response?.data || [],
    }),
    addEmailReport: builder.mutation({
      query: (addEmailReport) => ({
        url: "emailConfig",
        method: "POST",
        body: addEmailReport,
      }),
    }),

    editEmailReport: builder.mutation({
      query: ({ id, updatedData }) => ({
        url: `emailConfig/${id}`,
        method: "PUT",
        body: updatedData,
      }),
    }),
    getEmailReportById: builder.query({
      query: ({ id }) => `emailConfig/${id}`,
      transformResponse: (response) => response?.data || [],
    }),
    deleteEmailReport: builder.mutation({
      query: (id) => ({
        url: `emailConfig/${id}`,
        method: "DELETE",
      }),
    }),

    //END Hobbies API's---------------------------------------
  }),
});

export const {
  //Hobbie api
  useGetAllEmailReportQuery,
  useAddEmailReportMutation,
  useEditEmailReportMutation,
  useGetEmailReportByIdQuery,
  useDeleteEmailReportMutation,
} = EmailReportApi;

export default EmailReportApi;
